/*
 * @fileOverView Modal component definition
 */

import Vue from 'vue';
import slider from 'jquery-ui/ui/widgets/slider';
window.$ = window.jQuery = require('jquery');
require('jquery-ui-touch-punch');

/**
 * [Modal Vue]
 * @type {class}
 */
Vue.component('slider-vue', {
  data: function() {
    return {
      minValue: null,
      maxValue: null,
      minValueDisplay: null,
      maxValueDisplay: null,
      $slider: null
    }
  },

  watch: {
    minValue: function (val) {
      this.minValueDisplay = val;
    },

    maxValue: function (val) {
      this.maxValueDisplay = val;
    }
  },

  mounted() {
    this.minValue = $(this.$refs.minValue).data('range-value');
    this.maxValue = $(this.$refs.maxValue).data('range-value');

    this.$slider = $(this.$refs.slider).slider({
      range: true,
      min: this.minValue,
      max: this.maxValue,
      values: [this.minValue, this.maxValue],
      change: (e, ui) => {
        // Called when let go. Checking for the originalEvent ensures it's not
        // triggered by a programatic change to the min/max values.
        const handleIndex = parseInt(ui.handleIndex, 10);

        if (handleIndex === 0 && ui.values[0] !== this.minValue) {
          this.updateRangeValues(ui.values[0], null);
        }
        else if (handleIndex === 1 && ui.values[1] !== this.maxValue) {
          this.updateRangeValues(null, ui.values[1]);
        }
      },
      slide: (e, ui) => {
        // Called mid drag.
        this.updateDisplayValues(ui.values[0], ui.values[1]);
      }
    });
  },

  methods: {
    /**
     * Updates the slider handles when their mobile counterparts are changed.
     *
     * @param  {Number} selectedIndex The index of selected dropdown item.
     * @param  {String} selectedValue The value of the selected dropdown item.
     * @param  {Object} el            The dropdown element.
     */
    dropdownChanged: function (selectedIndex, selectedValue, el) {
      this.$slider.slider('values', el.parentNode.getAttribute('data-key'), selectedValue);
      this[el.parentNode.getAttribute('data-range')] = selectedValue;
      this[el.parentNode.getAttribute('data-range') + 'Display'] = selectedValue;
    },

    /**
     * Removes active styles from the handle upon letting go in touch devices.
     *
     * @param  {Object} e The touch event.
     */
    handleHandleTouchend: function (e) {
      e.currentTarget.blur();
    },

    /**
     * Resets the element to the default values.
     *
     * Exists to be used by parent elements, such as filters.
     */
    reset: function () {
      this.minValue = $(this.$refs.minValue).data('range-value');
      this.maxValue = $(this.$refs.maxValue).data('range-value');

      this.$emit('slider-changed', false, false, this.$el);
    },

    /**
     * Set the element to a specific value.
     *
     * Exists to be used by parent elements, such as filters.
     *
     * @param {String} value
     *   The value to set the element to, which is two values joined with '-'.
     */
    set: function (value) {
      const values = value.split('-');

      if (values.length === 2) {
        this.updateRangeValues(values[0], values[1]);
      }
    },

    /**
     * Updates the values shown to the end user.
     *
     * These change more often (as they're dragged) than the true values (when
     * let go) to avoid triggering the filter endpoint too early.
     *
     * @param  {Number} minValue The minimum value of the range.
     * @param  {Number} maxValue The maximum value of the range.
     */
    updateDisplayValues: function (minValue, maxValue) {
      this.minValueDisplay = minValue;
      this.maxValueDisplay = maxValue;
    },

    /**
     * Updates the true values of the slider's range.
     *
     * This is used as opposed to watching the variables so that one event can
     * be emmitted for both sides of the range (avoids dupe filter).
     *
     * @param  {Number} minValue The minimum value of the range.
     * @param  {Number} maxValue The maximum value of the range.
     */
    updateRangeValues: function (minValue, maxValue) {
      if (minValue) {
        this.minValue = minValue;
      }
      if (maxValue) {
        this.maxValue = maxValue;
      }

      this.$emit('slider-changed', this.minValue, this.maxValue, this.$el);
    }
  }
})
